import React from 'react';
import { useNavigate } from 'react-router-dom';
import Footer from './Footer';
import Header from './Header';
import './About.css';

const About = () => {
  const navigate = useNavigate();

  const products = [
    { icon: '🏆', name: 'Interview Assistant' },
    { icon: '🔮', name: 'Mock AI Interview' },
    { icon: '📄', name: 'Resume Builder' },
    { icon: '🛡️', name: 'Cover Letter' },
    { icon: '⭐', name: 'ATS Checker' },
    { icon: '🎨', name: 'Portfolio Builder' },
    { icon: '💎', name: 'Interview Questions' },
    { icon: '🎯', name: 'AI Quiz' },
    { icon: '📈', name: 'LinkedIn Optimizer' },
    { icon: '⚡', name: 'Auto Job Apply' },
  ];

  return (
    <div className="neural-glass-homepage">
      <div className="neural-background"></div>
      <div className="geometric-shapes">
        <div className="shape shape-1"></div>
        <div className="shape shape-2"></div>
        <div className="shape shape-3"></div>
        <div className="shape shape-4"></div>
      </div>

      <Header setShowAuthModal={() => {}} />

      <main className="about-main">

        {/* Hero */}
        <div className="about-hero">
          <div className="about-hero-badge">ABOUT TERVIEW AI</div>
          <h1 className="about-hero-title">
            Your AI-Powered<br />
            <span>Career Copilot</span>
          </h1>
          <p className="about-hero-desc">
            Terview AI is an all-in-one AI career platform built to help job seekers land their dream roles — with real-time interview assistance, smart resume tools, and automated job applications.
          </p>
        </div>

        {/* Stats
        <div className="about-stats">
          <div className="about-stat-card">
            <span className="about-stat-number">10+</span>
            <span className="about-stat-label">AI-Powered Tools</span>
          </div>
          <div className="about-stat-card">
            <span className="about-stat-number">50K+</span>
            <span className="about-stat-label">Users Worldwide</span>
          </div>
          <div className="about-stat-card">
            <span className="about-stat-number">99.9%</span>
            <span className="about-stat-label">Uptime</span>
          </div>
          <div className="about-stat-card">
            <span className="about-stat-number">🇮🇳</span>
            <span className="about-stat-label">Made in India</span>
          </div>
        </div>
         */}

        {/* Mission Cards */}
        <div className="about-mission">
          <div className="about-mission-card">
            <span className="about-mission-icon">🎯</span>
            <div className="about-mission-title">Our Mission</div>
            <div className="about-mission-desc">
              To democratize access to AI-powered career tools and give every job seeker — regardless of background — the confidence and skills to succeed in interviews and land their dream job.
            </div>
          </div>
          <div className="about-mission-card">
            <span className="about-mission-icon">🔮</span>
            <div className="about-mission-title">Our Vision</div>
            <div className="about-mission-desc">
              A world where no qualified candidate loses an opportunity due to lack of preparation or resources. We believe AI can level the playing field for job seekers globally.
            </div>
          </div>
          <div className="about-mission-card">
            <span className="about-mission-icon">💡</span>
            <div className="about-mission-title">Why We Built This</div>
            <div className="about-mission-desc">
              The job market is tough. Interview prep is expensive. Resume writing is time-consuming. Terview AI was born to solve all of this in one place — fast, smart, and affordable.
            </div>
          </div>
          <div className="about-mission-card">
            <span className="about-mission-icon">🚀</span>
            <div className="about-mission-title">What Makes Us Different</div>
            <div className="about-mission-desc">
              Unlike generic tools, Terview AI uses your actual resume and job description to generate personalized, context-aware responses — making every suggestion feel uniquely yours.
            </div>
          </div>
        </div>

        {/* Our Story */}
        <div className="about-story">
          <div className="about-story-title">Our Story</div>
          <p>
            Terview AI started with a simple observation: talented people were losing job opportunities not because they lacked skills, but because they weren't prepared for the interview process. The gap between capability and opportunity was costing people careers.
          </p>
          <p>
            Terview AI combines cutting-edge AI models with deep understanding of what hiring managers actually look for. From real-time interview assistance to automated job applications, every feature is designed with one goal — helping you get hired.
          </p>
          <p>
            Today, Terview AI serves thousands of users across the world, from fresh graduates to senior professionals, helping them walk into every interview with confidence.
          </p>
        </div>

        {/* Products */}
        <div>
          <h2 className="about-products-title">Everything You Need to Get Hired</h2>
          <p className="about-products-subtitle">10 powerful AI tools, one platform.</p>
          <div className="about-products-grid">
            {products.map((product, index) => (
              <div key={index} className="about-product-card">
                <span className="about-product-icon">{product.icon}</span>
                <span className="about-product-name">{product.name}</span>
              </div>
            ))}
          </div>
        </div>

        {/* CTA */}
        <div className="about-cta">
          <div className="about-cta-title">Ready to Land Your Dream Job?</div>
          <p className="about-cta-desc">Join thousands of job seekers already using Terview AI to ace their interviews.</p>
          <button className="about-cta-btn" onClick={() => navigate('/')}>
            Get Started Free →
          </button>
        </div>

      </main>

      <Footer />
    </div>
  );
};

export default About;